import React from 'react';
import {
  Button,
  Modal,
} from 'react-bootstrap';

const RemoveFromOrganizationModal = (props) => {
  const { showDemote, handleClose, handleDemoteUser } = props;
  return <Modal show={showDemote} onHide={handleClose}>
    <Modal.Dialog>
      <Modal.Header closeButton>
        <Modal.Title>Remove User(s) from Organization(s)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to remove selected user(s) from the organization(s)?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          className="btn btn-custom white mr-3"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button variant="outline-danger" onClick={handleDemoteUser}>
          Remove user(s) from organization(s)
        </Button>
      </Modal.Footer>
    </Modal.Dialog>
  </Modal>
}

export default RemoveFromOrganizationModal;